import { render, staticRenderFns } from "./PushMessageContent.vue?vue&type=template&id=14651dc8&scoped=true&"
import script from "./PushMessageContent.vue?vue&type=script&lang=js&"
export * from "./PushMessageContent.vue?vue&type=script&lang=js&"
import style0 from "./PushMessageContent.vue?vue&type=style&index=0&id=14651dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14651dc8",
  null
  
)

export default component.exports